export default __webpack_public_path__ + "static/media/support-location.33cb0b60.svg";